import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { WizardImportModule } from '@barthauer/abc/interfaces/core/wizards/import';
import {
  _AbcFileUploaderComponent,
  AbcDropDownBoxComponent,
  AbcTextBoxComponent,
  AbcUiComponentsModule,
} from '@barthauer/abc/ui-components';
import { AsciiImportComponent } from './ascii-import.component';
import { AsciiImportService } from './ascii-import.service';
import { SettingSelectionPageComponent } from './pages/setting-selection-page/setting-selection-page.component';
import { SettingShapeselectionPageComponent } from './pages/setting-shapeselection-page/setting-shapeselection-page.component';

@NgModule({
  declarations: [AsciiImportComponent, SettingSelectionPageComponent, SettingShapeselectionPageComponent],
  providers: [AsciiImportService],
  imports: [CommonModule, WizardImportModule, AbcTextBoxComponent, AbcDropDownBoxComponent, _AbcFileUploaderComponent],
})
export class AbcInterfacesCommonAsciiWizardsImportModule {}
